export default {
  title: 'Jadwal Pengiriman',
  transportType: 'Kendaraan',
  driver: 'Sopir',
  orderCompleted: 'Pesanan Selesai',
  orderInProcess: 'Dalam Proses',
  scheduled: 'Terjadwal',
  canceled: 'Batal',
  today: 'Hari Ini',
}
